// shared/dc-row-protection.js
//
// PR R (sub_R2, 2026-09-28) — single definition of "delete-protected" Daily
// Calcs brand row, shared between backend (guard + dc-field, via require —
// same ESM-from-CJS pattern as shared/schemas/dc-field.js) and frontend
// (delete-target filtering, tombstone cleanup — imported from
// src/pages/DailyCalcs/calc.js, which re-exports isBlankMoney from here).
//
// A brand row is delete-protected once it carries data worth not losing
// silently: an anchor date (Balance Yesterday was entered and stamped),
// an explicit archive flag, or a non-blank Balance Yesterday value. Such a
// row must be archived (dc-field `archived:true`), never deleted — see
// backend/services/daily-calcs-post-guard.cjs (general POST) and
// backend/routes/atomic/dc-field.cjs is NOT a delete path, only the guard is.
//
// Affiliate rows and any non-brand type are never delete-protected — the
// anchor triple / archived flag only ever exist on brand rows (see
// backend/routes/atomic/dc-field.cjs, the field is legal only for type
// 'brand').

/**
 * '' (and null/undefined/whitespace) is the only "not entered" sentinel for
 * a DC money cell — '0' / '$0' are real entered values. Copied verbatim from
 * src/pages/DailyCalcs/calc.js so the two call sites (browser and Node) never
 * drift; calc.js now re-exports this definition instead of keeping its own.
 *
 * @param {*} v
 * @returns {boolean}
 */
export function isBlankMoney(v) {
  return v == null || String(v).trim() === '';
}

/**
 * A brand row that must not be deleted outright (server-enforced — see the
 * general-POST guard's `delete_protected` rejection). Such a row can only be
 * archived (dc-field `archived:true`) or, once archived/anchored/moneyed, sit
 * in the archive.
 *
 * @param {{ type?: string, anchorAsOf?: string, archived?: boolean, balanceNoCrg?: * }} row
 * @returns {boolean}
 */
export function isDeleteProtectedDcRow(row) {
  if (!row || row.type !== 'brand') return false;
  if (row.anchorAsOf) return true;
  if (row.archived === true) return true;
  if (!isBlankMoney(row.balanceNoCrg)) return true;
  return false;
}
